/**
 * CommunityChatMessageType enum
 * Defines the type of a community chat message.
 * Matches Flutter implementation: lib/domain/enums/community_chat_message_type.dart
 *   enum CommunityChatMessageType { text, image, video, gift, live }
 *
 * The Firestore field `type` is an `int` (ordinal). Numeric values mirror the
 * Dart enum's declaration order: text=0, image=1, video=2, gift=3, live=4.
 */
export enum CommunityChatMessageType {
  text = 0,
  image = 1,
  video = 2,
  gift = 3,
  live = 4,
}
